import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cz-language-translation',
  templateUrl: './language-translation.component.html',
  styleUrls: ['./language-translation.component.scss'],
})
export class LanguageTranslationComponent implements OnInit, OnDestroy {
  @Input() public language: {[key: string]: string};
  @Input() public menuPresentation: boolean;
  @Input() public langSelected: string;
  @Output() public selectionChanged: EventEmitter<string> = new EventEmitter<string>();
  public cultureCookie: string;
  public objectKeys: (o: {}) => string[] = Object.keys;
  public form: FormGroup;
  public languageControl: FormControl;
  private readonly _cookieName: string = 'Allow-Cookies';

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly _translate: TranslateService, private readonly _cookieService: CookieService) {}

  public ngOnInit(): void {
    // this.cultureCookie = this._cookieService.get('Culture');
    this.cultureCookie = this.langSelected;
    const languageValue: string = this.cultureCookie || this._translate.getDefaultLang();
    this.languageControl = new FormControl(languageValue);
    this._translate.use(languageValue);
    this.form = new FormGroup({
      language: this.languageControl,
    });

    this.languageControl.valueChanges.pipe(
      takeUntil(this.destroy$))
      .subscribe((language: string) => {
        if (!language) { return; }

        this.languageSelected(language);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public languageSelected(language: string): void {
    this._translate.setDefaultLang(language);
    this._translate.use(language);
    if (localStorage.getItem(this._cookieName)) {
      this._cookieService.set('Culture', language, undefined, '/');
    }
    this.selectionChanged.emit(language);
  }
}
